import {SVGProps} from "react";

export const SearchSvg = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M12.4638 13.3701C11.3591 14.2741 9.94702 14.8165 8.40823 14.8165C4.86906 14.8165 2 11.9474 2 8.40823C2 4.86906 4.86906 2 8.40823 2C11.9474 2 14.8165 4.86906 14.8165 8.40823C14.8165 9.94702 14.2741 11.3591 13.3701 12.4638L17.1921 16.2858C17.4423 16.5361 17.4423 16.9418 17.1921 17.1921C16.9418 17.4423 16.5361 17.4423 16.2858 17.1921L12.4638 13.3701ZM13.5348 8.40823C13.5348 11.2396 11.2396 13.5348 8.40823 13.5348C5.57689 13.5348 3.28165 11.2396 3.28165 8.40823C3.28165 5.57689 5.57689 3.28165 8.40823 3.28165C11.2396 3.28165 13.5348 5.57689 13.5348 8.40823Z"
                  fill="currentColor" />
        </svg>
    )
}
